import React, { useState, useEffect } from "react";
import API_DOMAIN from "../config/config";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import Logo from "../assests/images/logo2.png";
const DOMAIN = "https://sivakasiogcrackers.com/api";

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    backgroundColor: "#FFFFFF",
    padding: 26,
    position: "relative",
  },
  section: {
    flexDirection: "column",
    flexGrow: 1,
    border: 1,
    display: "flex",
  },
  text: {
    fontSize: 13,
    fontFamily: "Times-Roman",
    textAlign: "center",
    borderBottom: 1,
    width: "100%",
  },
  headertext: {
    fontSize: 10,
    fontFamily: "Times-Roman",
    borderBottom: 1,
    width: "100%",
    padding: 2,
  },
  head: {
    fontSize: 10,
    display: "flex",
    flexDirection: "row",
    textAlign: "center",
  },
  invoice: {
    flex: 200,
    fontWeight: "bolder",
    fontSize: 13,
  },
  table: {
    display: "flex",
    borderBottom: 0.5,
    padding: 6,
    justifyContent: "flex-end",
  },
  tableRow: {
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  tableCell: {
    flex: 4,
    fontSize: 9,
    fontFamily: "Times-Roman",
  },
  producthead: {
    marginTop: 0,
    borderBottom: 1,
  },
  producttitle: {
    flexDirection: "row",
    padding: 1,
    fontWeight: "bold",
    fontSize: 9,
    borderBottom: 1,
    borderBottomColor: "#000",
    borderBottomStyle: "solid",
  },
  productbody: {
    flexDirection: "row",
    padding: 1,
    fontSize: 9,
  },
  no: { width: "8%", textAlign: "center", fontSize: 9 },
  particular: { width: "34%", textAlign: "left", fontSize: 9 },
  qty: { width: "10%", textAlign: "center", fontSize: 9 },
  unit: { width: "12%", textAlign: "center", fontSize: 9 },
  price: { width: "18%", textAlign: "right", fontSize: 9 },
  amount: { width: "18%", textAlign: "right", fontSize: 9 },
  bodydescription: {
    flexDirection: "column",
  },
  rateinctax: {
    width: "15%",
    textAlign: "center",
    padding: 5,
  },
  rate: {
    width: "15%",
    textAlign: "center",
    padding: 5,
  },
  footer: {
    fontSize: 9,
    display: "flex",
    justifyContent: "flex-end",
  },
  footerRow: {
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  footerleft: {
    height: 62,
    borderBottom: 0.5,
  },
  footerCell: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    paddingVertical: 5,
    width: "100%",
  },
  right: {
    textAlign: "right",
  },
  totalBox: {
    position: "absolute",
  },
  w70: {
    width: "70%",
  },
  w30: {
    width: "30%",
  },
  priceRow: {
    flexDirection: "row",
    justifyContent: "flex-end",
    borderBottom: 1,
    flexGrow: 15,
  },
  priceCell: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    paddingVertical: 5,
    flexGrow: 10,
    borderRight: 1,
    padding: 4,
    flexShrink: 1,
  },
  overall: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    paddingVertical: 5,
    padding: 5,
    flexGrow: 2.5,
    marginTop: 6,
  },
  paymentDetails: {
    marginTop: 10,
    marginBottom: 10,
  },
  paymentRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: 2,
  },
  paymentMethod: {
    fontSize: 9,
    fontFamily: "Times-Roman",
  },
  paymentAmount: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    textAlign: "right",
  },
  signbox: {
    fontSize: 9,
    display: "flex",
    position: "absolute",
    bottom: 0,
    width: "100%",
    borderBottom: 1,
    borderBottomColor: "#000",
    borderBottomStyle: "solid",
  },
  signdesk: {
    height: 55,
  },
  signbill: {
    flexDirection: "row",
  },
  customsign: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    paddingVertical: 2,
    flexGrow: 200,
    marginTop: 30,
    marginLeft: 3,
  },
  docs: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    paddingVertical: 2,
    marginRight: 3,
    marginTop: 30,
  },
  declration: {
    fontSize: 8,
    padding: 1,
  },
  boxdetails: {
    display: "flex",
    flexDirection: "row",
    borderBottom: 1,
  },
  boxdetailss: {
    display: "flex",
    flexDirection: "row",
  },
  box: {
    fontSize: 9,
    width: "50%",
    padding: 5,
  },
  brdright: { borderRight: 1 },
  brdrights: { borderRight: 1, borderBottom: 1 },
  brdrightss: { borderBottom: 1 },
  brdtop: {
    borderTopWidth: 1,
    borderTopColor: "#000",
    borderTopStyle: "solid",
    width: "50%",
    paddingBottom: 1,
  },
  print: {
    fontSize: 9,
    textAlign: "right",
  },
  companyname: {
    fontWeight: "bold",
    fontSize: 9,
  },
  billed: {
    fontSize: 11,
    fontWeight: "bold",
  },
  boldText: {
    fontFamily: "Times-Roman",
    fontWeight: "bold",
    fontSize: 11,
  },
  ewayno: {
    marginBottom: 2,
    fontSize: 11,
    fontWeight: "bold",
  },
  stateof: {
    fontSize: 11,
    fontWeight: "bold",
  },
  remarks: {
    fontSize: 6,
  },
  watermark: {
    position: "absolute",
    top: "17%",
    left: "15%",
    right: "0%",
    width: "80%",
    height: "60%",
    opacity: 0.2,
    margin: "0 auto",
    display: "flex",
  },
});

// Helper function to chunk array into groups of specified size
const chunkArray = (array, size) => {
  const result = [];
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size));
  }
  return result;
};

const Onlinebillpdf = ({ data, type }) => {
  // Ensure data and data.products are defined
  const products = Array.isArray(data?.products) ? data.products : [];
  const PRODUCTS_PER_PAGE = 40;

  // Split products into chunks of 40
  const productChunks = chunkArray(products, PRODUCTS_PER_PAGE);

  // Calculate GST amounts
  const totalGST = Number(data.gst_amount || 0).toFixed(2);
  const isIGST = (data.gst_type || "").toLowerCase().includes("igst");
  const sgstAmount = isIGST ? "0.00" : (Number(totalGST) / 2).toFixed(2);
  const cgstAmount = isIGST ? "0.00" : (Number(totalGST) / 2).toFixed(2);

  // Function to convert rupees to words
  function convertRupeesToWordsWithBreaks(amount) {
    const ones = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
    ];
    const teens = [
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const tens = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];
    const thousands = ["", "Thousand", "Lakh", "Crore"];

    function convertGroup(number, thousandIndex) {
      if (number === 0) return "";
      let str = "000" + number;
      str = str.slice(-3);
      const hundred = parseInt(str[0], 10);
      const ten = parseInt(str[1], 10);
      const one = parseInt(str[2], 10);
      let words = [];
      if (hundred > 0) words.push(ones[hundred] + " Hundred");
      if (ten === 1) {
        words.push(teens[one]);
      } else {
        if (ten > 0) words.push(tens[ten]);
        if (one > 0) words.push(ones[one]);
      }
      if (thousandIndex > 0 && words.length > 0)
        words.push(thousands[thousandIndex]);
      return words.join(" ");
    }

    function convertIntegerPart(integerPart) {
      const groups = [];
      let thousandIndex = 0;
      while (integerPart > 0) {
        groups.push(
          convertGroup(
            integerPart % (thousandIndex === 1 ? 100 : 1000),
            thousandIndex
          )
        );
        integerPart = Math.floor(
          integerPart / (thousandIndex === 1 ? 100 : 1000)
        );
        thousandIndex++;
      }
      const resultGroups = groups.reverse().filter((group) => group !== "");
      return resultGroups.join(" ");
    }

    function convertDecimalPart(decimalPart) {
      if (decimalPart === 0) return "";
      let paise = Math.round(decimalPart * 100);
      return convertGroup(paise, 0) + " Paise";
    }

    const integerPart = Math.floor(amount || 0);
    const decimalPart = (amount || 0) - integerPart;
    const integerWords = convertIntegerPart(integerPart);
    const decimalWords = convertDecimalPart(decimalPart);
    const result =
      integerWords + " Rupees" + (decimalWords ? "\nAnd " + decimalWords : "");
    return result.trim();
  }

  const [userdata, setUserData] = useState({});
  const fetchData = async () => {
    try {
      const response = await fetch(`${DOMAIN}/company.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ search_text: "" }),
      });

      if (!response.ok) throw new Error("Failed to fetch data");
      const responseData = await response.json();
      if (responseData.head.code === 200) {
        setUserData(responseData.body.company);
      } else {
        throw new Error(responseData.head.msg);
      }
    } catch (error) {
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const words = convertRupeesToWordsWithBreaks(data?.discount_total || 0);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };

  // Render empty row with blank spaces
  const renderEmptyRow = (index) => (
    <View style={styles.productbody} key={`empty-${index}`}>
      <Text style={styles.no}> </Text>
      <Text style={styles.particular}> </Text>
      <Text style={styles.qty}> </Text>
      <Text style={styles.unit}> </Text>
      <Text style={styles.price}> </Text>
      <Text style={styles.amount}> </Text>
    </View>
  );

  // Common header content
  const renderHeader = () => (
    <>
      <View style={styles.header}>
        <View style={styles.headertext}>
          <Text style={styles.print}>[{type}]</Text>
          <View style={styles.head}>
            <Text style={styles.invoice}>Online Bill</Text>
          </View>
        </View>
      </View>
      <View style={styles.boxdetails}>
        <View style={[styles.box, styles.brdright]}>
          <Text>
            Bill No:{" "}
            {data.tax_invoice_no ? data.tax_invoice_no : data.enquiry_no}
          </Text>
        </View>
        <View style={styles.box}>
          <Text>Date: {formatDate(data.bill_date)}</Text>
        </View>
      </View>
      <View style={styles.boxdetailss}>
        <View style={[styles.box, styles.brdrights]}>
          <Text style={[styles.billed, styles.boldText]}>
            Billed By: SIVAKASI OG CRACKERS
          </Text>
          <Text>
            Address: Durga Bakery, opposite Vembakottai Road,
            Vanamoorthilingapuram, Sivakasi, Tamil Nadu 626124
          </Text>
          <Text>Phone Number: 9363505881,8015063808</Text>
          <Text>GST No: {userdata.gst_no || " "}</Text>
        </View>
        <View style={[styles.box, styles.brdrightss]}>
          <Text style={styles.ewayno}>To: {data?.customer_name || " "}</Text>
          <Text style={styles.ewayno}>Address: {data?.address || " "}</Text>
          <Text style={styles.ewayno}>Mobile Number: {data?.phone || " "}</Text>
          {data?.email ? (
            <Text style={styles.ewayno}>Email: {data.email}</Text>
          ) : null}
        </View>
      </View>
    </>
  );

  // Footer content (bank details, totals, remarks)
  const renderFooter = () => (
    <>
      <View style={styles.boxdetails}>
        <View style={[styles.box, styles.brdright, styles.w70]}>
          <Text>Bank Name: {userdata.bank_name || " "}</Text>
          <Text>Account No: {userdata.acc_no || " "}</Text>
          <Text>IFSC: {userdata.ifsc_code || " "}</Text>
        </View>
        <View style={[styles.box, styles.w30]}>
          <Text>Sub Total: {data.sub_total}</Text>
          <Text>
            Discount:
            {data?.discount_type === "Discount Amount"
              ? data?.discount || "0"
              : ((data?.sub_total * (data?.discount || 0)) / 100).toFixed(2)}
          </Text>
          {isIGST ? (
            <Text>IGST: {totalGST}</Text>
          ) : (
            <>
              <Text>SGST: {sgstAmount}</Text>
              <Text>CGST: {cgstAmount}</Text>
            </>
          )}
        </View>
      </View>
      <View style={styles.footer}>
        <View style={styles.priceRow}>
          <Text style={[styles.priceCell, styles.w70]}>
            Amount in words: {words} Only
          </Text>
          <Text style={[styles.overall, styles.w30]}>
            Final Amount: {data?.discount_total || "0"}
          </Text>
        </View>
      </View>
      {data?.remark && (
        <View style={styles.boxdetails}>
          <Text style={[styles.billed, styles.boldText]}>Remarks:</Text>
          <View style={styles.paymentDetails}>
            <View style={styles.paymentRow}>
              <Text style={styles.paymentMethod}>{data.remark}</Text>
            </View>
          </View>
        </View>
      )}
    </>
  );

  // Signature section (Customer Sign and For [company_name])
  const renderSignatures = () => (
    <View style={styles.signbox}>
      <View style={styles.signdesk}>
        <View style={styles.signbill}>
          <View style={styles.customsign}>
            <Text>Customer Sign</Text>
          </View>
          <Text style={styles.docs}>For SIVAKASI OG CRACKERS</Text>
        </View>
      </View>
    </View>
  );

  return (
    <Document>
      {productChunks.length > 0 ? (
        productChunks.map((chunk, pageIndex) => (
          <Page size="A4" style={styles.page} key={pageIndex}>
            {/* <Image style={styles.watermark} src={Logo} /> */}
            <View style={styles.section}>
              {renderHeader()}
              <View style={styles.producthead}>
                {/* Table Header */}
                <View style={styles.producttitle}>
                  <Text style={styles.no}>S No</Text>
                  <Text style={styles.particular}>Product Name</Text>
                  <Text style={styles.qty}>Qty</Text>
                  <Text style={styles.unit}>Unit</Text>
                  <Text style={styles.price}>Price</Text>
                  <Text style={styles.amount}>Total</Text>
                </View>
                {/* Table Body */}
                <View style={styles.bodydescription}>
                  {chunk.map((product, index) => {
                    const qty = parseFloat(product?.qty) || 0;
                    const perPrice = parseFloat(product?.per_price) || 0;
                    const total = (qty * perPrice).toFixed(2);
                    const globalIndex =
                      pageIndex * PRODUCTS_PER_PAGE + index + 1;

                    return (
                      <View style={styles.productbody} key={index}>
                        <Text style={styles.no}>{globalIndex}</Text>
                        <Text style={styles.particular}>
                          {product?.product_name || ""}
                        </Text>
                        <Text style={styles.qty}>{qty}</Text>
                        <Text style={styles.unit}>
                          {product?.unit_name || ""}
                        </Text>
                        <Text style={styles.price}>{perPrice.toFixed(2)}</Text>
                        <Text style={styles.amount}>{total}</Text>
                      </View>
                    );
                  })}
                  {/* Fill remaining rows with empty rows */}
                  {chunk.length < PRODUCTS_PER_PAGE &&
                    Array.from({
                      length: PRODUCTS_PER_PAGE - chunk.length,
                    }).map((_, index) => renderEmptyRow(index))}
                </View>
              </View>
              {/* Render footer (bank details, totals, remarks) */}
              {renderFooter()}
              {/* Render signatures at the bottom */}
              {renderSignatures()}
            </View>
          </Page>
        ))
      ) : (
        <Page size="A4" style={styles.page}>
          <Image style={styles.watermark} src={Logo} />
          <View style={styles.section}>
            {renderHeader()}
            <View style={styles.producthead}>
              {/* Table Header */}
              <View style={styles.producttitle}>
                <Text style={styles.no}>S No</Text>
                <Text style={styles.particular}>Product Name</Text>
                <Text style={styles.qty}>Qty</Text>
                <Text style={styles.unit}>Unit</Text>
                <Text style={styles.price}>Price</Text>
                <Text style={styles.amount}>Total</Text>
              </View>
              {/* Table Body */}
              <View style={styles.bodydescription}>
                <View style={styles.productbody}>
                  <Text style={styles.no}> </Text>
                  <Text style={styles.particular}>No Products Available</Text>
                  <Text style={styles.qty}> </Text>
                  <Text style={styles.unit}> </Text>
                  <Text style={styles.price}> </Text>
                  <Text style={styles.amount}> </Text>
                </View>
                {/* Fill remaining rows with empty rows */}
                {Array.from({ length: PRODUCTS_PER_PAGE - 1 }).map((_, index) =>
                  renderEmptyRow(index)
                )}
              </View>
            </View>
            {/* Render footer (bank details, totals, remarks) */}
            {renderFooter()}
            {/* Render signatures at the bottom */}
            {renderSignatures()}
          </View>
        </Page>
      )}
    </Document>
  );
};

export default Onlinebillpdf;

